import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useConfig } from "../../../../_shared";
import { OpenService } from "../../../../types/config";
import { DurationInput } from "./DurationInput";

const { Text } = Typography;

export const TicketLifetimeOption = observer(() => {
  const t = useTranslation();
  const { message } = useFeedback();
  const config = useConfig<number>(
    OpenService.ConfigKeys.closedTicketsLifetime
  );

  async function saveConfig(value: number) {
    if (await config.saveConfig(JSON.stringify(value))) {
      message.success(t("maintenance:global.messages.save.success"));
    }
  }

  return (
    <Flex vertical gap={12} align="flex-start" justify="start">
      <Text>
        {t("maintenance:administration.general.ticket_lifetime.label")}
      </Text>
      <DurationInput
        value={config.value ? Number.parseInt(config.value.toString()) : 0}
        onChange={saveConfig}
      />
    </Flex>
  );
});
